module.exports = __webpack_public_path__ + "static/media/mach20autos.75322233.jpeg";